import { gql } from '@apollo/client';

export const UPDATE_FEATURES = gql`
  mutation UPDATE_FEATURES($feature: TenantFeatureModelInput!, $key: String!) {
    updateFeature(feature: $feature, key: $key) {
      name
      label
      enabled
      hidden
      config
      orderedFeatures {
        name
        label
        enabled
        config
        orderedFeatures {
          name
          label
          enabled
          config
          orderedFeatures {
            name
            label
            enabled
            config
          }
        }
      }
    }
  }
`;
